import planConsentTemplate from "./PlanConsentTemplate";

var EDeliveryDirective = function () {
    return {
        restrict: "E",
        controller: "EDeliveryDisplayController",
        controllerAs: "vm",
        scope: true,
        template: planConsentTemplate
    };
};

export default EDeliveryDirective;